import React, { useEffect, useState } from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse, Modal } from "antd";
import { FormatDateTime } from "../../../utility/format";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { BadgePill } from "../../../badge_pill/badge_pill";
import ApproveProcessLogModal from "../../../approve_process/approve_process_log_modal";
import ApproveProcessModal from "../../../approve_process/approve_process_modal";
import DynamicLabelGroup from "../../../dynamic_label/dynamic_label_group";
import moment from "moment";
import { connect } from "react-redux";
import Cookies from "js-cookie";
const { Panel } = Collapse;

function CheckAlarm({
  title,
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  Jobdata,
  language,
  factupdate,
}) {
  return (
    <>
      <Collapse
        className="container"
        expandIconPosition="right"
        defaultActiveKey={["1"]}
      >
        <Panel
          header={
            <div className="font-thai-b fs-18">
              <img
                src={Api.absoluteUrl(`/icon/alert.svg`)}
                alt={title}
                className="mr-2 mb-1"
              />
              <span className="c-blue text-uppercase">{title}</span>
            </div>
          }
          key="1"
          className="font-thai-r fs-18 my-0"
        >
              <div  className="card mb-2">
                <div className="card-body px-1 py-1">
                  <h5 className={`${ !Jobdata.result_job_detail[0].eventEndTime ? "c-blue" : "c-green" } pl-2`}>
                    <i className="fa fa-circle fa-xs mr-2"></i>
                    {"DTAC EVENT END TIME"}
                  </h5>
                  <div className="card-text">
                    <div className="col-12">
                      <span className="pl-0 pr-1">{`Date/time`} :</span>
                      <span className="">
                            {Jobdata.result_job_detail[0].eventEndTime ? moment(Jobdata.result_job_detail[0].eventEndTime).format("DD/MM/YYYY HH:mm") : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
        </Panel>
      </Collapse>

    </>
  );
}
const mapStateToProps = (state) => ({
  language: state.masterLang.masterLang,
  factupdate: state.masterLang.factUpdate,
});
export default connect(mapStateToProps)(CheckAlarm);
